import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import SuperAdminHeader from './SuperAdminHeader'
import EditBranch from './EditBranch'
import AssignBranch from './AssignBranch'
import { useNavigate } from 'react-router-dom'
import { FaEdit, FaTrashAlt, FaUserPlus } from 'react-icons/fa'

export default function PendingBranchAllocation() {
  const token = localStorage.getItem('token')
  const navigate = useNavigate()
  const [branches, setBranches] = useState([])
  const [selectedBranch, setSelectedBranch] = useState(null)

  const fetchBranches = async() => {
    try{
      const res = await axios.get(`${config.baseurl}get_pending_branches/`, {
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('Branch Res:', res)

      if(res.status === 200){
        setBranches(res.data.data)
      }else{
        toast.error('Failed to fetch branches')
      }
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create branch'

      toast.error(message)
    }
  }

  useEffect(() => {
    fetchBranches()
  },[token])
  console.log('Branches:', branches)

  const handleDelete = async(id) => {
    console.log('Branch Id:', id)

    if(!id){
      toast.error('Invalid Branch id')
      return
    }

    try{
      const res = await axios.delete(`${config.baseurl}delete_branch/${id}/`,{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })

      toast.success('Branch Deleted Successfully')
      await fetchBranches()
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create branch'

      toast.error(message)
    }
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <SuperAdminHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
          PENDING BRANCH ALLOCATION
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          View and manage all registered branches in one place.
        </p>
      </div>

      <div className='max-w-7xl mx-auto px-6 pb-10'>
        <div className='bg-white rounded-lg shadow-sm border border-slate-300 overflow-hidden'>
          <div className='overflow-x-auto overflow-y-auto max-h-[70vh]'>
            <table className='w-full table-auto'>
              <thead>
                <tr className='text-center border-b border-slate-300'>
                  <th className='px-3 py-2 whitespace-nowrap'>No</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Branch Name</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Address</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Email</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Phone Number</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Actions</th>
                </tr>
              </thead>

              <tbody>
                {branches.length > 0 ? (
                  branches.map((item, index) => (
                    <tr
                      key={item.id}
                      className='text-center border-b border-b-slate-300'
                    >
                      <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.branch_name}</td>
                      <td className='px-3 py-2 max-w-[250px] break-words whitespace-normal'>{item.address}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.email}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.phone}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>
                        <div className='flex items-center justify-center gap-3'>
                          <button
                            title='Edit'
                            onClick={() => {
                              setSelectedBranch(item)
                              navigate(`/super_admin/edit_branch/${item.id}`)
                            }}
                            className='bg-blue-500 text-white px-3 py-2 rounded-lg hover:bg-blue-600'
                          >
                            <FaEdit/>
                          </button>

                          <button
                            title='Delete'
                            onClick={() => handleDelete(item.id)}
                            className='bg-red-500 text-white px-3 py-2 rounded-lg hover:bg-red-600'
                          >
                            <FaTrashAlt/>
                          </button>

                          <button
                            title='Assign'
                            onClick={() => {
                              setSelectedBranch(item)
                              navigate(`/super_admin/assign_branch/${item.id}`)
                            }}
                            className='bg-green-500 text-white px-3 py-2 rounded-lg hover:bg-green-600'
                          >
                            <FaUserPlus/>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      className='text-center py-6'
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
